import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.getCSVDownloadStudentList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.getCSVDownloadStudentList.error;
export const csvDownloadStudentListResponse = (state: RootState) =>
  state.getCSVDownloadStudentList.csvDownloadStudentListResponse;
